/** Barrel: re-exporta infra customer partida por dominio. */
export {
  findDuplicateCustomers,
  getCustomerAppointmentsPreview,
  getCustomerSalesSummary,
  invalidateWebCustomerSnapshotAfterWrite,
  shouldReadCustomerFromRemoteOnWeb,
} from './customerRepositoryShared';
export type { CustomerAppointmentPreview, CustomerSalesSummary } from './customerRepositoryShared';

export {
  countCustomerAccounts,
  createCustomer,
  fetchCustomerAccounts,
  getCustomerAccountById,
  toggleCustomerBlockState,
  updateCustomerProfile,
} from './customerAccounts';

export { recordCustomerCharge } from './customerCharges';

export {
  getCustomerSalesForCustomer,
  recordCustomerPayment,
  type SalePaymentAllocationSyncRow,
} from './customerPayments';

export {
  DEFAULT_MOVEMENTS_PAGE_SIZE,
  fetchCustomerMovements,
  getCustomerMovementHistory,
  getCustomerMovementHistoryForExport,
} from './customerMovementHistory';

export { getOrCreatePortalToken } from './customerPortal';

export { getCustomerDaySummary, updateCustomerNameAndCuit } from './customerDaySummary';

export { getCustomerKpiSummary } from './customerKpiSummary';
